<template>
  <div class="flex items-start mb-4 pb-4 border-b-2">
    <div class="md:w-4/5 flex flex-col">
      <div class="flex flex-col mb-3">
        <span class="text-left pb-2 uppercase text-sm tracking-wider">Pregunta</span>
        <input
          :class="{'border-red-500': question.error}"
          class="bg-gray-200 appearance-none border-2 border-orange-500 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-orange-300"
          type="text"
          v-model="question.value"
        />
        <p v-if="question.error" class="text-red-500 text-xs italic text-left">Ingrese la pregunta.</p>
      </div>
      <div class="flex flex-wrap -mx-3 mb-0">
        <div class="w-5/12 px-3 mb-6 md:mb-0">
          <!-- <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
            for="activity"
          >Categoría</label>-->
          <div class="relative mb-3">
            <select
              class="block appearance-none w-full bg-gray-200 border-2 border-orange-500 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-orange-300"
              name="start"
              v-model="question.range[0]"
            >
              <option>0</option>
              <option>1</option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-2/12 px-3 mb-6 md:mb-0">
          <div class="flex items-center justify-center h-full -mt-1">a</div>
        </div>
        <div class="w-5/12 px-3 mb-6 md:mb-0">
          <!-- <label
            class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
            for="activity"
          >Categoría</label>-->
          <div class="relative mb-3">
            <select
              class="block appearance-none w-full bg-gray-200 border-2 border-orange-500 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-orange-300"
              name="end"
              v-model="question.range[1]"
            >
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
              <option>9</option>
              <option>10</option>
            </select>
            <div
              class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
            >
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path
                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mb-3">
        <div class="w-1/2 px-3 mb-6 md:mb-0">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs mb-2 text-left"
            for="latitude"
          >Etiqueta inicio (opcional)</label>
          <input
            class="appearance-none block w-full bg-gray-200 text-gray-700 border-2 border-orange-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-orange-300"
            name="startLabel"
            type="text"
            v-model="question.labels[0]"
          />
        </div>
        <div class="w-1/2 px-3 mb-6 md:mb-0">
          <label
            class="block uppercase tracking-wide text-gray-700 text-xs mb-2 text-left"
            for="longitude"
          >Etiqueta fin (opcional)</label>
          <input
            class="appearance-none block w-full bg-gray-200 text-gray-700 border-2 border-orange-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-orange-300"
            name="endLabel"
            type="text"
            v-model="question.labels[1]"
          />
        </div>
      </div>
    </div>
    <div class="md:w-1/5 flex justify-center">
      <button
        type="button"
        class="flex items-center px-2 py-1 rounded bg-red-500 text-gray-100 hover:bg-red-700"
        @click="remove"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
          <path d="M0 0h24v24H0z" fill="none" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "scale-question",
  methods: {
    remove() {
      this.$emit("click");
    }
  },
  props: {
    question: {
      required: true
    }
  }
};
</script>

<style scoped>
</style>